module.exports = __webpack_public_path__ + "img/collect_icon_05.9a85c880.png";